export default {
    api_path: "https://martech-api-us.apachedigital.io/"
    // api_path: "https://martech-api-staging.apachedigital.io/"
}


